import { render } from "./AgentChatHeader.vue?vue&type=template&id=fc54ad16&scoped=true"
import script from "./AgentChatHeader.vue?vue&type=script&lang=js"
export * from "./AgentChatHeader.vue?vue&type=script&lang=js"

import "./AgentChatHeader.vue?vue&type=style&index=0&id=fc54ad16&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc54ad16"]])

export default __exports__